import { Registration, UserType } from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

// These requests to go the /register nextjs lambda
// creates a customer at the time of subscription being created
export const createSubscription = async (
  body: Extract<Registration.Request, { type: "individual" | "business" }>
): Promise<Registration.Response<"individual" | "business">> =>
  fetchFromAPI(`/register`, {
    method: "POST",
    body: JSON.stringify(body),
    passthrough: "edge",
  });

export const createFreeAccount = async (
  body: Extract<Registration.Request, { type: "pay-as-you-go" }>
): Promise<Registration.Response<"pay-as-you-go">> =>
  fetchFromAPI(`/register`, {
    method: "POST",
    body: JSON.stringify(body),
    passthrough: "edge",
  });

export const updateSubscription = async (
  processorId: string,
  args: { shortCode: string; addons: any[] }
): Promise<UserType> =>
  fetchFromAPI(`/subscriptions/${processorId}`, {
    method: "PATCH",
    body: JSON.stringify(args),
  });

export const resumeSubscription = async (): Promise<UserType> =>
  fetchFromAPI("/subscriptions/resume", {
    method: "POST",
  });

export const pauseSubscription = async (): Promise<UserType> =>
  fetchFromAPI("/subscriptions/pause", {
    method: "POST",
  });
